const featureSettings = {
    enable_transport_collaboration: false, // https://gitlab.spacefill.fr/groups/spacefill/-/epics/317
    enable_integration_activities: false, // https://gitlab.spacefill.fr/groups/spacefill/-/epics/384
    enable_custom_units: false,
};

export { featureSettings };
